<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center mb-2">
      <v-btn color="primary" tile outlined @click="getdata()">
        <v-icon small>mdi-reload</v-icon>刷新
      </v-btn>
      <v-btn color="success" tile @click="showadd">
        <v-icon small>mdi-plus</v-icon>新增角色
      </v-btn>
    </div>
    <v-card>
      <v-data-table dense :headers="headers" :items="list" :items-per-page="list.length" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:item.permissions="{ item }">
          <div class="d-flex flex-column">
            <span v-for="p in item.permissions" :key="p._id">
              {{ p.title }}（{{p.list.map(n => n.title).join('，')}}）
            </span>
          </div>
        </template>
        <template v-slot:item.spermission="{ item }">
          <v-checkbox v-model="item.showincomeprofit" label="显示收入利润" dense hide-details
            @change="(v) => updatePermission(item._id, 'showincomeprofit', v)"></v-checkbox>
          <v-checkbox v-model="item.filtersection" label="关联标段数据" dense hide-details
            @change="(v) => updatePermission(item._id, 'filtersection', v)"></v-checkbox>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn text color="success" @click="showedit(item)">
            编辑
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="model" persistent max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="form.name" :rules="[vrules.required]" placeholder="角色名" persistent-placeholder
                    dense outlined>
                    <template v-slot:label>
                      角色名 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                  <v-text-field v-model="form.value" :rules="[vrules.required]" :disabled="form._id !== ''"
                    placeholder="角色值" persistent-placeholder dense outlined>
                    <template v-slot:label>
                      角色值 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                  <v-expansion-panels accordion hover multiple tile v-model="activeKeys">
                    <v-expansion-panel v-for="(item, i) in permissions" :key="i">
                      <v-expansion-panel-header>
                        {{ item.label }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="d-flex flex-wrap">
                          <v-checkbox v-for="(pitem, j) in item.options" :key="j" v-model="form.permissions"
                            :label="pitem.label" :value="pitem.value" hide-details></v-checkbox>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "SystemAccount",
  data() {
    return {
      valid: true,
      list: [],
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      activeKeys: [],
      form: {},
      permissions: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["username"]),
    headers() {
      return [
        { text: "角色名", value: "name", width: 120 },
        { text: "角色值", value: "value", width: 120 },
        { text: "开通权限", value: "permissions" },
        ...(this.username === 'root' ? [
          { text: "特殊权限", value: "spermission", width: 150 },
        ] : []),
        { text: "创建时间", value: "create_time" },
        { text: "操作", value: "action", width: 120, fixed: "right" },
      ];
    },
  },
  components: {},
  watch: {},
  mounted() {
    this.height = window.innerHeight - 150;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 150;
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/role/list").then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list.map(n => {
            return {
              ...n,
              create_time: this.$utils.dateFormat(n.create_time, 'YYYY-MM-DD HH:mm:ss'),
            };
          });
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getinfo(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/role/info", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.form = res.data.dataForm;
          this.permissions = res.data.permissions;
          this.activeKeys = _.pluck(res.data.permissions, "index");
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    updatePermission(_id, key, value) {
      console.log('updatePermission', _id, key, value);
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/role/update", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.getinfo().then(() => {
        this.modeltitle = "新增角色";
        this.model = true;
      });
    },
    showedit(item) {
      this.getinfo(item._id).then(() => {
        this.modeltitle = "编辑角色";
        this.model = true;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      let dataForm = {
        _id: this.form._id,
        name: this.form.name,
        value: this.form.value,
        permissions: this.permissions.map(n => {
          return n.options.filter(m => this.form.permissions.includes(m.value));
        }).filter(n => n.length > 0).reduce((a, b) => a.concat(b.map(n => n.value)), []),
      }
      this.$api.doAPI("/role/save", { dataForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .v-expansion-panel-header {
  min-height: unset !important;
}

p {
  margin: 0;
}
</style>
